import { DESKTOP_FOOTER_BREAKPOINT, TABLET_FOOTER_BREAKPOINT } from '../styles'
import { media } from '@app/common/src/theme'
import { theme } from '@dtx-company/design-system/src/theme'
import styled from 'styled-components'

export const MobileFooterWrapper = styled.footer<{ padding?: string }>`
  ${media.custom(DESKTOP_FOOTER_BREAKPOINT)} {
    display: none;
  }
  grid-area: footer;
  align-self: end;
  z-index: 1000;
  background-color: ${theme.palette.primary.dark};
  display: flex;
  flex-direction: column;
  padding: ${({ padding }) => padding || '35px'};
  /* Ensure proper spacing for touch targets */
  gap: 8px;
  ${media.custom(TABLET_FOOTER_BREAKPOINT)} {
    padding: ${({ padding }) => padding || '35px'};
  }
  ${media.custom(DESKTOP_FOOTER_BREAKPOINT)} {
    padding: ${({ padding }) => padding || '0 96px 0 50px'};
    height: 100px;
  }
`

export const DesktopFooterWrapper = styled.div`
  display: none;
  ${media.custom(DESKTOP_FOOTER_BREAKPOINT)} {
    display: flex;
  }
  background-color: ${theme.palette.primary.dark};
  flex-direction: column;
  grid-area: footer;
  grid-gap: 4px;
  padding: 24px 24px 12px 24px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  z-index: 1000;
`

export const FooterAnchor = styled.a`
  :link,
  :active,
  :hover,
  :visited {
    text-decoration: none;
  }
  margin: 2px;
  ${media.custom(DESKTOP_FOOTER_BREAKPOINT)} {
    margin: 0 5px;
    padding: 4px 8px;
  }
  cursor: pointer;
`

export const FooterIcon = styled.a`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
  svg {
    fill: white;
  }
`
